document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('keyup', (e) => {
        const key = e.key;

        if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
            if (document.activeElement.id === 'global-command' && key === 'Escape'){
                document.activeElement.blur();
            }
            return;
        }

        if (e.ctrlKey && key === '/'){
            e.preventDefault();
            let searchBox = document.getElementById('q');
            searchBox.focus();
        }

        if (key === 'j'){
            e.preventDefault();
            let currentCursorIndex = getCurrentCursorIndex();
            if (currentCursorIndex === null){
                setCursor(0);
            } else {
                setCursor(currentCursorIndex + 1);
            }
        }

        if (key === 'k') {
            e.preventDefault();
            let currentCursorIndex = getCurrentCursorIndex();
            if (currentCursorIndex === null){
                setCursor(0);
            } else {
                setCursor(currentCursorIndex - 1);
            }
        }

        if (['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(key)){
            e.preventDefault();
            let link = document.querySelector('a.search-target[data-shortcut-key="' + key + '"]');
            location.href = link.getAttribute('href');
        }


        if (key === 'Enter'){
            e.preventDefault();
            let targetLink = document.querySelector('.result.active a.result-url');
            if (targetLink !== null){
                location.href = targetLink.getAttribute('href');
            }
        }
    });
});

function setCursor(idx){
    let currentResult = document.querySelector('.result.active');
    let newCurrentResult = document.querySelector(`.result[data-index="${idx}"]`);

    if (currentResult !== null && newCurrentResult !== null){
        currentResult.classList.remove('active');
        currentResult.classList.remove('border-warning');

        newCurrentResult.classList.add('active');
        newCurrentResult.classList.add('border-warning');
    } else if (currentResult === null && newCurrentResult !== null){
        newCurrentResult.classList.add('active');
        newCurrentResult.classList.add('border-warning');
    }
}

function getCurrentCursorIndex(){
    let cursor = document.querySelector('.result.active');
    if (cursor === null){
        return null;
    }
    return parseInt(cursor.getAttribute('data-index'));
}
